import React, { useCallback } from 'react';
import { NumericFormat } from 'react-number-format';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { LabelTypography } from './amountCardsStyle';
import {
  useStyles,
  PercentAllocationLabelTypography,
  PercentAllocationTypography,
  AllocationSubtitleTypography,
} from './fundAllocationCardStyle';

export default function FundAllocationCard({
  title,
  subtitle,
  formData,
  setFormData,
  field,
  onUpdateAllocation,
}) {
  const classes = useStyles();

  const calculateAllocationPercent = () => {
    const fieldValue = parseFloat(formData[field] || 0);
    const amountValue = parseFloat(formData.amount || 0);

    if (amountValue == 0) { return '0.00'; } // Avoid division by zero

    return ((fieldValue / amountValue) * 100).toFixed(2);
  };

  const handleBlur = useCallback(
    (event) => {
      const formattedValue = event.target.value;
      const numericValue = formattedValue.replace(/[$,]/g, '');
      setFormData((prevData) => {
        const updatedFormData = { ...prevData, [field]: numericValue };
        onUpdateAllocation(updatedFormData);
        return updatedFormData;
      });
    },
    [field, setFormData],
  );

  return (
    <Grid container className={classes.card}>
      <Grid item xs={12} lg={6} className={classes.description}>
        <Typography variant="h3" component="label">
          {title}
        </Typography>
        <AllocationSubtitleTypography
          component="div"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      </Grid>
      <Grid item xs={12} lg={3} className={classes.inputGridItem}>
        <LabelTypography style={{ color: '#7b5599', fontWeight: 600 }}>
          Enter Allocation:
        </LabelTypography>
        <div className={classes.inputContainer}>
          <NumericFormat
            className={classes.input}
            value={formData[field]}
            prefix="$"
            type="text"
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            placeholder="$0"
            maxLength={50}
            decimalScale={0}
            onBlur={handleBlur}
            disabled={formData.amount <= 0}
            allowNegative={false}
          />
        </div>
      </Grid>
      <Grid item xs={12} lg={3} className={classes.allocationPercent}>
        <PercentAllocationLabelTypography>
          Total % Allocated:
        </PercentAllocationLabelTypography>
        <PercentAllocationTypography
          style={{ padding: '0 5px' }}
        >{`${calculateAllocationPercent()}%`}
        </PercentAllocationTypography>
      </Grid>
    </Grid>
  );
}

FundAllocationCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  onUpdateAllocation: PropTypes.func.isRequired,
};
